var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('p',[_c('ul',[_c('h2',[_vm._v("0.12.5")]),_c('li',[_vm._v("Peer-to-peer communications with server")]),_c('li',[_vm._v("Owners list in Feed Plan")]),_c('li',[_vm._v("Alert in Feed Schedule (not fed/partial fed)")]),_c('li',[_vm._v("Bush Droppings")])])]),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }